var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("b-navbar", {
        scopedSlots: _vm._u([
          {
            key: "brand",
            fn: function() {
              return [
                _c(
                  "b-navbar-item",
                  { attrs: { tag: "router-link", to: { path: "/" } } },
                  [_c("img", { attrs: { src: require("@/assets/logo.png") } })]
                )
              ]
            },
            proxy: true
          },
          {
            key: "start",
            fn: function() {
              return [
                _c(
                  "b-navbar-item",
                  { attrs: { href: "#" } },
                  [
                    _c("router-link", { attrs: { to: "/admin_login" } }, [
                      _vm._v("管理者作業開始画面")
                    ]),
                    _vm._v(" /\n        "),
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _vm._v("QRコード読み取り画面")
                    ])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "end",
            fn: function() {
              return undefined
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41458b80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41458b80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 